import {
  GET_WRAPPINGS_START,
  GET_WRAPPINGS_ERROR,
  GET_WRAPPINGS_SUCCESS,
} from '../constants';

import getWrappingsQuery from './queries/getWrappings.graphql';

export default function getWrappings() {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: GET_WRAPPINGS_START,
      payload: {
        loading: true,
      },
    });
    try {
      const {
        data: {
          wrappings: {
            filter: { items = [], pagingInfo },
          },
        },
        errors,
      } = await client.query({
        query: getWrappingsQuery,
        variables: {
          input: { withStatus: 'Active' },
          pagination: { page: 1, perPage: 50 },
        },
        context: {
          service: 'graphqlHost',
        },
      });

      if (errors && errors.length) {
        dispatch({
          type: GET_WRAPPINGS_ERROR,
          payload: {
            errors: errors.map(err => err.message),
            loading: false,
          },
        });
      } else {
        dispatch({
          type: GET_WRAPPINGS_SUCCESS,
          payload: {
            data: { items, pagingInfo },
            loading: false,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: GET_WRAPPINGS_ERROR,
        payload: {
          errors: [error].map(e => e.message),
          loading: false,
        },
      });
    }
    const state = getState();
    return state && state.wrapping ? state.wrapping : {};
  };
}
